import { SELL_API as axios } from '@services/axiosInstance';
import type { Plan } from '@t/productOffering.types';
import type { ProductOfferingDTO } from '@t/api.types';
import { mapEvOfferingsToPlan, mapOfferingsToPlan } from '@utils/productOfferingMapper';

export const fetchProductOfferings = async (sessionId: string, homeId: string): Promise<Plan[]> => {
  const { data } = await axios.get<ProductOfferingDTO[]>(`/sessions/${sessionId}/productOffering/${homeId}/offers`);
  return mapOfferingsToPlan(data);
};

export const fetchEvOfferings = async (sessionId: string): Promise<Plan[]> => {
  const { data } = await axios.get<ProductOfferingDTO[]>(`/sessions/${sessionId}/productOffering/ev/offers`);
  return mapEvOfferingsToPlan(data);
};

export const fetchEvOfferingDtoById = async (
  sessionId: string,
  offeringId: string,
  href?: string
): Promise<ProductOfferingDTO> => {
  const { data } = await axios.get<ProductOfferingDTO>(
    `/sessions/${sessionId}/productOffering/ev/offerings/${offeringId}`,
    href ? { params: { href } } : undefined
  );
  return data;
};

export const fetchEvOfferingById = async (sessionId: string, offeringId: string, href?: string): Promise<Plan> => {
  const data = await fetchEvOfferingDtoById(sessionId, offeringId, href);
  return mapEvOfferingsToPlan([data])[0];
};

export const fetchEquipment = async (
  sessionId: string,
  homeId: string,
  planId: string
): Promise<ProductOfferingDTO[]> => {
  const { data } = await axios.get<ProductOfferingDTO[]>(
    `/sessions/${sessionId}/productOffering/${homeId}/plans/${planId}/equipment`
  );
  return data;
};
